<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import Card from 'primevue/card';

import ColoredText from '@/components/ColoredText.vue';
import { useEstimatedSegments } from '@/composables/useEstimatedSegments';
import { useVisibleCalculationItems } from '@/composables/useVisibleCalculationItems';
import DefaultChip from '../components/DefaultChip.vue';
import CalculationItemsVisibilityButton from '../components/CalculationItemsVisibilityButton.vue';

const { hiddenFilter } = useVisibleCalculationItems();

const reactiveFilters = computed(() => ({
  hidden: hiddenFilter.value,
  includeChildRules: false,
  ruleTypes: ['calculation'],
  includeSegmentRules: true,
  includeGroupRules: true,
}));

const { segmentRules } = useEstimatedSegments(reactiveFilters);

const route = useRoute();

const currentSegmentRules = computed(() => {
  return segmentRules.value?.filter(
    (segment) => segment.id === Number(route.params.segmentId) && segment.rules.length
  );
});

const currentSegmentGroupRules = computed(() => {
  return currentSegmentRules.value?.map((segment) => {
    return {
      ...segment,
      groups: segment.groups.filter(
        (group) => group.id === Number(route.params.groupId) && group.rules.length
      ),
    };
  });
});
</script>

<template>
  <Card v-if="currentSegmentRules?.length" class="border border-gray-200 !shadow-none">
    <template #content>
      <header class="text-md mb-4 flex justify-between items-center font-bold text-gray-900">
        <span>Podsumowanie obliczeń</span>
        <CalculationItemsVisibilityButton />
      </header>

      <div :key="segment.id" v-for="segment in currentSegmentGroupRules" class="space-y-1">
        <div :key="group.id" v-for="group in segment.groups" class="space-y-1">
          <div class="font-bold text-gray-900">{{ group.name }}</div>

          <div class="text-sm text-gray-iron-700">
            <!-- v-for="groupRule in group.rules.filter((r) => Number(r.eval) !== 0)" -->

            <div
              :key="groupRule.id"
              v-for="groupRule in group.rules"
              class="flex items-center justify-between py-3.5"
            >
              <ColoredText :variant="groupRule.color" class="max-w-40 text-sm">
                {{ groupRule.name }}
              </ColoredText>

              <DefaultChip
                v-tooltip.top="groupRule.expression"
                class="max-w-80 overflow-x-auto"
                :variant="groupRule.color"
              >
                {{ groupRule.eval }}
                {{ groupRule.unit }}
              </DefaultChip>
            </div>
          </div>
        </div>

        <div class="font-bold text-gray-900">Podsumowanie {{ segment.name }}</div>

        <div class="text-sm text-gray-iron-700">
          <!-- v-for="rule in segment.rules.filter((r) => Number(r.eval) !== 0)" -->

          <div
            :key="rule.id"
            v-for="rule in segment.rules"
            class="flex items-center justify-between py-3.5"
          >
            <ColoredText :variant="rule.color" class="max-w-40 text-sm">
              {{ rule.name }}
            </ColoredText>

            <DefaultChip
              v-tooltip.top="rule.expression"
              class="max-w-80 overflow-x-auto"
              :variant="rule.color"
            >
              {{ rule.eval }}
              {{ rule.unit }}
            </DefaultChip>
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>
